import type { ChangeEvent } from 'react';
import { TextInput } from '@pixum/web-input';
import type { AddressFormData } from '../../../types';

interface AddressIdentityFieldsProps {
  formData: AddressFormData;
  company: boolean;
  constants: Record<string, string>;
  fieldError: (name: string) => string | undefined;
  fieldName: (name: string) => string;
  formId?: string;
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  pickupPoint: boolean;
}

export function AddressIdentityFields({
  formData,
  company,
  constants,
  fieldError,
  fieldName,
  formId,
  onInputChange,
  pickupPoint
}: AddressIdentityFieldsProps) {
  return (
    <>
      {company && !pickupPoint && (
        <TextInput
          label={constants['i18n_company']}
          form={formId}
          name={fieldName('company')}
          value={formData.company}
          onChange={onInputChange}
          hasError={Boolean(fieldError('company'))}
          inputInfo={fieldError('company')}
        />
      )}
      <TextInput
        label={constants['i18n_first_name']}
        form={formId}
        name={fieldName('firstName')}
        value={formData.firstName}
        onChange={onInputChange}
        hasError={Boolean(fieldError('firstName'))}
        inputInfo={fieldError('firstName')}
      />
      <TextInput
        label={constants['i18n_last_name']}
        form={formId}
        name={fieldName('lastName')}
        value={formData.lastName}
        onChange={onInputChange}
        hasError={Boolean(fieldError('lastName'))}
        inputInfo={fieldError('lastName')}
      />
    </>
  );
}